import { Triggers } from "processEditor/model/ITriggerData";
import { ITriggerValidatorProps } from "./validateConditionalTriggers";
import { addNameValidationError } from "../ValidateProcess";
import { ValidationErrorType } from "processEditor/model/ValidationData";

export default function ({ triggers, validationErrors: existingErrors }: ITriggerValidatorProps) {
    const httpTriggersWithMissingUrl =
        triggers.filter((element) => element?.selectedTypeId === Triggers.HttpTrigger.triggerType
            && (!element?.parameters?.routeTemplate || element?.parameters?.routeTemplate.trim().length == 0)); // All HTTP triggers should have a URL

    httpTriggersWithMissingUrl.forEach((element) => {
        addNameValidationError(existingErrors, ValidationErrorType.HttpTriggerMissingUrl, element?.id);
    });
}